import * as React from "react";
const SvgSubMenu = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 5.5L22 5.5M2 12H17M2 18.5L22 18.5", stroke: "#969696", strokeWidth: 1.5, strokeMiterlimit: 10 }));
export default SvgSubMenu;
